// Expands/collapses a category's own children in place (the + / − button
// in collection-sidebar-tree.liquid), independent of the label next to
// it, which still navigates normally — lets someone check whether a
// category has sub-categories worth looking at before committing to it.
// Works the same at both levels the menu nests to (top-level branches
// and their own children), since both render the same toggle markup.
//
// This is just a class toggle — the open/close animation itself is
// handled entirely by CSS (grid-template-rows 0fr/1fr on the wrapping
// .sublist-wrap/.subsublist-wrap, see collection-sidebar.css), including
// nested lists resizing their parent correctly. No height measuring here.
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('.collection-sidebar-tree__toggle');
  if (!toggle) return;
  var item = toggle.closest('.collection-sidebar-tree__item, .collection-sidebar-tree__subitem');
  if (!item) return;

  event.preventDefault();
  var opening = !item.classList.contains('is-open');
  item.classList.toggle('is-open', opening);
  toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
});
